var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModalSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#C8E6CD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E8F5EB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 27.58V28.5C37.9988 30.6564 37.3005 32.7547 36.0093 34.4818C34.7182 36.209 32.9033 37.4725 30.8354 38.0839C28.7674 38.6953 26.5573 38.6219 24.5345 37.8746C22.5117 37.1273 20.7847 35.7461 19.611 33.9371C18.4373 32.128 17.8798 29.9881 18.0217 27.8363C18.1636 25.6846 18.9972 23.6363 20.3983 21.9971C21.7994 20.3578 23.6928 19.2154 25.7962 18.7401C27.8996 18.2649 30.1003 18.4823 32.07 19.36M38 20.5L28 30.51L25 27.51",
    stroke: "#489F56",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModalSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/modalSuccess.49d5fec937bd9a38983258fa5ea6cb10.svg";